var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_vm.playground.id ? _c('h3', [_vm._v(_vm._s(_vm.sessionType) + ": " + _vm._s(_vm.playground.name || _vm.playground.id))]) : _vm._e(), _c('playground-card')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }